/**
 * @generated SignedSource<<2a06a0be709ae9f227b257bc99acdd4b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type KPIListInputItem_taskExecution$data = {
  readonly goals: {
    readonly greaterThan: number | null;
    readonly lessThan: number | null;
  } | null;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"TaskExecutionNumberComponent_TaskExecutionNumber">;
  readonly " $fragmentType": "KPIListInputItem_taskExecution";
};
export type KPIListInputItem_taskExecution$key = {
  readonly " $data"?: KPIListInputItem_taskExecution$data;
  readonly " $fragmentSpreads": FragmentRefs<"KPIListInputItem_taskExecution">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "KPIListInputItem_taskExecution",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TaskExecutionNumberComponent_TaskExecutionNumber"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskNumberGoals",
      "kind": "LinkedField",
      "name": "goals",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lessThan",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "greaterThan",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TaskExecutionNumber",
  "abstractKey": null
};

(node as any).hash = "86ec9e7ece87c8e9d14dfd71ae3b7def";

export default node;
